"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var LEFT_BUTTON = 0; // Cmd/Ctrl/Shift/Alt + Click should trigger default browser behaviour. Same applies to non-left clicks

var isPlainLeftClick = function isPlainLeftClick(e) {
  return e.button === LEFT_BUTTON && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey;
};

var RoutedLink =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RoutedLink, _React$Component);

  function RoutedLink() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RoutedLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RoutedLink)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onClick", function (e) {
      var onClick = _this.props.onClick;

      if (isPlainLeftClick(e)) {
        e.preventDefault();
        onClick(e);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(RoutedLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          href = _this$props.href,
          children = _this$props.children,
          onClick = _this$props.onClick,
          className = _this$props.className,
          style = _this$props.style;
      var props = onClick ? {
        href: href,
        className: className,
        style: style,
        onClick: this.onClick
      } : {
        href: href,
        className: className,
        style: style
      };
      return _react.default.createElement("a", props, children);
    }
  }]);
  return RoutedLink;
}(_react.default.Component);

exports.default = RoutedLink;
RoutedLink.defaultProps = {
  onClick: null,
  href: '#',
  children: null,
  className: undefined,
  style: undefined
};
RoutedLink.propTypes = {
  onClick: _propTypes.default.func,
  href: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: _propTypes.default.object
};